import { useState, useEffect } from "react";
import { useAuth } from "../Context/AuthContext";
import API from "../Context/api";
import ErrorMessage from "../Helpers/ErrorMessage";

function AddInvoiceForm({ setIsModalOpen, onInvoiceUpdated }) {
  const [customer, setCustomer] = useState("");
  const [items, setItems] = useState([]);
  const [particulars, setParticulars] = useState("");
  const [quantity, setQuantity] = useState("");
  const [rate, setRate] = useState("");
  const [totalAmount, setTotalAmount] = useState(0);
  const [vat, setVat] = useState(0);
  const [amountInWords, setAmountInWords] = useState("");
  const [finalTotalAmount, setFinalTotalAmount] = useState(0);
  const [isLoading, setIsLoading] = useState(false); // Loading state
  const [errorMessage, setErrorMessage] = useState("");

  const isFormValid =
    customer.trim() !== "" && items.length > 0 && amountInWords.trim() !== "";

  const { user } = useAuth();
  const createdBy = user ? user.name : "";

  // Calculate total, VAT, and final total whenever items change
  useEffect(() => {
    const calculatedTotal = items.reduce((sum, item) => sum + item.total, 0);
    setTotalAmount(calculatedTotal);

    const calculatedVat = Math.round(calculatedTotal * 0.18); // 18% VAT
    setVat(calculatedVat);

    const finalTotal = calculatedTotal + calculatedVat;
    setFinalTotalAmount(finalTotal);
  }, [items]);

  // Add item to the invoice
  const addItem = () => {
    const parsedQty = parseInt(quantity, 10);
    const parsedRate = parseFloat(rate);

    if (particulars.trim() !== "" && parsedQty > 0 && parsedRate > 0) {
      const total = parsedQty * parsedRate;
      setItems([
        ...items,
        { particulars, quantity: parsedQty, rate: parsedRate, total },
      ]);
      setParticulars("");
      setQuantity("");
      setRate("");
    }

    // if (particulars.trim() !== "" && quantity > 0 && rate > 0) {
    //   const total = quantity * rate; // Calculate total for the item
    //   setItems([...items, { particulars, quantity, rate, total }]);
    //   setParticulars(""); // Reset particulars field
    //   setQuantity(0); // Reset quantity
    //   setRate(0); // Reset rate
    // }
  };

  // Delete an item from the invoice
  const deleteItem = (index) => {
    setItems(items.filter((_, i) => i !== index));
  };

  // Save invoice to the backend
  const saveInvoice = async () => {
    if (!customer.trim() || items.length === 0 || !amountInWords.trim()) {
      alert(
        "Please add a customer name, at least one item, and the amount in words."
      );
      return;
    }

    setIsLoading(true); // Set loading state to true

    const invoiceData = {
      customer: { client: customer },
      items,
      invoiceHeader: {
        companyName: "KEVMARK INVESTMENTS LTD",
        companyTIN: "1000135996",
        address:
          "Plot 59 Nkrumah-Nasser Link Plaza Nsooba, P.O. Box 71341 Kampala",
        phone: "0752 / 0772-551",
        email: ["kevmark2000@gmail.com", "sales@kevmarkinvestments.com"],
        description:
          "Stationary, Scholastic Materials, Toners, Computers, Computer Hardware and Software Maintenance",
      },
      invoiceDetails: {
        date: new Date().toISOString().slice(0, 10),
        totalAmount: finalTotalAmount,
        vat,
        amountInWords,
      },
      createdBy,
    };

    try {
      // Make API request to backend to save the invoice
      await API.post("/invoices", invoiceData);
      // Reset form after successful invoice creation
      setCustomer("");
      setAmountInWords("");
      setItems([]);
      onInvoiceUpdated(); // Refresh the parent component
      setIsModalOpen(false); // Close the modal
    } catch (error) {
      console.error("Error saving invoice:", error);
      setErrorMessage(
        error.response?.data?.message ||
          "An error occurred during user creation"
      );
    } finally {
      setIsLoading(false); // Set loading state to false
    }
  };

  return (
    // <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-60 p-3 sm:p-4 z-50">
    //   <div className="w-full max-w-md sm:max-w-lg lg:max-w-2xl bg-white rounded-xl shadow-lg overflow-hidden transform transition-all duration-300 scale-100">
    //     <div className="p-4 sm:p-6 max-h-[85vh] overflow-y-auto">
    //       <h2 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-4">
    //         Add New Invoice
    //       </h2>
    //       {/* Customer Input */}
    //       <div className="mb-4">
    //         <input
    //           type="text"
    //           className="border border-gray-300 p-2 rounded w-full mb-2"
    //           placeholder="Customer Name"
    //           value={customer}
    //           onChange={(e) => setCustomer(e.target.value)}
    //         />
    //       </div>

    //       {/* Item Input Section */}
    //       <div className="grid grid-cols-1 md:grid-cols-4 gap-2 mb-4">
    //         <input
    //           type="text"
    //           className="border border-gray-300 p-2 rounded"
    //           placeholder="Particulars"
    //           value={particulars}
    //           onChange={(e) => setParticulars(e.target.value)}
    //         />
    //         <input
    //           type="number"
    //           className="border border-gray-300 p-2 rounded"
    //           placeholder="Qty"
    //           value={quantity}
    //           onChange={(e) => setQuantity(parseInt(e.target.value) || 0)} // Ensure it's a number
    //         />
    //         <input
    //           type="number"
    //           className="border border-gray-300 p-2 rounded"
    //           placeholder="Rate (UGX)"
    //           value={rate}
    //           onChange={(e) => setRate(parseFloat(e.target.value) || 0)} // Ensure it's a number
    //         />
    //         <button
    //           onClick={addItem}
    //           className="bg-blue-500 text-white px-4 py-2 rounded"
    //         >
    //           Add Item
    //         </button>
    //       </div>

    //       {/* Display Added Items */}
    //       <div className="flex-1 overflow-y-auto mb-4">
    //         <table className="w-full border-collapse border border-gray-300">
    //           <thead>
    //             <tr className="bg-gray-200">
    //               <th className="border p-2">Particulars</th>
    //               <th className="border p-2">Qty</th>
    //               <th className="border p-2">Rate (UGX)</th>
    //               <th className="border p-2">Total (UGX)</th>
    //               <th className="border p-2">Actions</th>
    //             </tr>
    //           </thead>
    //           <tbody>
    //             {items.map((item, index) => (
    //               <tr key={index} className="text-center">
    //                 <td className="border p-2">{item.particulars}</td>
    //                 <td className="border p-2">{item.quantity}</td>
    //                 <td className="border p-2">{item.rate}</td>
    //                 <td className="border p-2">{item.total}</td>
    //                 <td className="border p-2">
    //                   <button
    //                     onClick={() => deleteItem(index)}
    //                     className="bg-red-500 text-white px-2 py-1 rounded"
    //                   >
    //                     Delete
    //                   </button>
    //                 </td>
    //               </tr>
    //             ))}
    //           </tbody>
    //         </table>
    //       </div>

    //       {/* Invoice Totals */}
    //       <div className="mt-4 text-right text-lg font-semibold text-gray-800">
    //         <p>Sub Total: UGX {totalAmount.toLocaleString()}</p>
    //         <p>VAT 18%: UGX {vat.toLocaleString()}</p>
    //         <p>Grand Total: UGX {finalTotalAmount.toLocaleString()}</p>
    //       </div>

    //       {/* Amount in Words */}
    //       <div>
    //         <input
    //           type="text"
    //           className="border border-gray-300 p-2 rounded w-full my-2"
    //           placeholder="Amount in words"
    //           value={amountInWords}
    //           onChange={(e) => setAmountInWords(e.target.value)}
    //         />
    //       </div>

    //       {/* Action Buttons */}
    //       <div className="mt-4 flex justify-end space-x-2">
    //         <button
    //           onClick={saveInvoice}
    //           className={`${
    //             isLoading
    //               ? "bg-gray-400 cursor-not-allowed"
    //               : "bg-green-500 hover:bg-green-600"
    //           } text-white px-4 py-2 rounded`}
    //           disabled={isLoading} // Disable the button when loading
    //         >
    //           {isLoading ? "Submitting..." : "Save Invoice"}
    //         </button>
    //         <button
    //           onClick={() => setIsModalOpen(false)}
    //           className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
    //         >
    //           Cancel
    //         </button>
    //       </div>
    //     </div>
    //   </div>
    // </div>
    <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-60 p-3 sm:p-4 z-50">
      <div className="w-full h-[450px] p-4 max-h-[80vh] max-w-md sm:max-w-lg lg:max-w-2xl bg-white rounded-xl shadow-lg overflow-hidden transform transition-all duration-300 scale-100 flex flex-col">
        {/* Header (Static) */}
        <div className="">
          {/* Static Header */}
          <h2 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-4">
            Add New Invoice
          </h2>
          <ErrorMessage message={errorMessage} />
        </div>
        <div className="">
          <input
            type="text"
            className="border border-gray-300 p-2 rounded w-full mb-2"
            placeholder="Customer Name"
            value={customer}
            onChange={(e) => setCustomer(e.target.value)}
          />
        </div>

        {/* Item Input Section */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-2 mb-4">
          <input
            type="text"
            className="border border-gray-300 p-2 rounded"
            placeholder="Particulars"
            value={particulars}
            onChange={(e) => setParticulars(e.target.value)}
          />
          <input
            type="number"
            className="border border-gray-300 p-2 rounded"
            placeholder="Qty"
            value={quantity}
            // onChange={(e) => setQuantity(parseInt(e.target.value) || 0)} // Ensure it's a number
            onChange={(e) => setQuantity(e.target.value)}
          />
          <input
            type="number"
            className="border border-gray-300 p-2 rounded"
            placeholder="Rate (UGX)"
            value={rate}
            onChange={(e) => setRate(parseFloat(e.target.value) || 0)} // Ensure it's a number
          />
          <button
            onClick={addItem}
            className="bg-blue-500 text-white px-4 py-2 rounded"
          >
            Add Item
          </button>
        </div>

        {/* Scrollable Content */}
        <div className="flex-1 overflow-y-auto space-y-3">
          <table className="w-full border-collapse border border-gray-300">
            <thead>
              <tr className="bg-gray-200">
                <th className="border p-2">Particulars</th>
                <th className="border p-2">Qty</th>
                <th className="border p-2">Rate (UGX)</th>
                <th className="border p-2">Total (UGX)</th>
                <th className="border p-2">Actions</th>
              </tr>
            </thead>
            <tbody>
              {items.map((item, index) => (
                <tr key={index} className="text-center">
                  <td className="border p-2">{item.particulars}</td>
                  <td className="border p-2">{item.quantity}</td>
                  <td className="border p-2">{item.rate}</td>
                  <td className="border p-2">{item.total}</td>
                  <td className="border p-2">
                    <button
                      onClick={() => deleteItem(index)}
                      className="bg-red-500 text-white px-2 py-1 rounded"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {/* Invoice Totals */}
          <div className="mt-4 text-right text-lg font-semibold text-gray-800">
            <p>Sub Total: UGX {totalAmount.toLocaleString()}</p>
            <p>VAT 18%: UGX {vat.toLocaleString()}</p>
            <p>Grand Total: UGX {finalTotalAmount.toLocaleString()}</p>
          </div>
        </div>

        <div className="mt-2 p-2">
          {/* Amount in Words */}
          <div>
            <input
              type="text"
              className="border border-gray-300 p-2 rounded w-full my-2"
              placeholder="Amount in words"
              value={amountInWords}
              onChange={(e) => setAmountInWords(e.target.value)}
            />
          </div>

          {/* Action buttons */}
          <div className="flex justify-end gap-3 ">
            <button
              type="button"
              onClick={() => setIsModalOpen(false)}
              className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 text-sm font-medium transition-all duration-200 shadow-sm w-full sm:w-auto"
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={saveInvoice}
              disabled={!isFormValid || isLoading}
              className={`px-4 py-2 rounded-md text-sm font-medium transition-all duration-200 shadow-sm w-full sm:w-auto ${
                !isFormValid || isLoading
                  ? "bg-gray-300 text-gray-600 cursor-not-allowed"
                  : "bg-blue-500 text-white hover:bg-blue-600"
              }`}
            >
              {isLoading ? "Submitting..." : "Submit"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddInvoiceForm;
